import * as React from 'react';

const SvgBag = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44.893 13.02h-.933l-7.887-7.887c-.63-.63-1.657-.63-2.31 0-.63.63-.63 1.657 0 2.31l5.577 5.577H16.66l5.576-5.577c.63-.63.63-1.656 0-2.31-.63-.63-1.656-.63-2.31 0l-7.863 7.887h-.933c-2.1 0-6.464 0-6.464 5.973 0 2.264.467 3.757 1.447 4.737.56.583 1.237.887 1.96 1.05.677.163 1.4.187 2.1.187h35.654c.723 0 1.4-.047 2.053-.187 1.96-.467 3.453-1.867 3.453-5.787 0-5.973-4.363-5.973-6.44-5.973ZM44.45 28H11.363a2.33 2.33 0 0 0-2.31 2.707l1.96 11.993c.654 4.013 2.404 8.633 10.174 8.633h13.09c7.863 0 9.263-3.943 10.103-8.353l2.357-12.203A2.325 2.325 0 0 0 44.45 28ZM24.757 43.05c0 .91-.724 1.633-1.61 1.633-.91 0-1.634-.723-1.634-1.633v-7.7c0-.887.724-1.633 1.634-1.633.886 0 1.61.746 1.61 1.633v7.7Zm9.986 0c0 .91-.723 1.633-1.633 1.633a1.638 1.638 0 0 1-1.633-1.633v-7.7c0-.887.746-1.633 1.633-1.633.91 0 1.633.746 1.633 1.633v7.7Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgBag;
